function DetailField({ label, value }) {
  return (
    <div className="p2">
      <h4 className="descriptiontitle mtb">{label}</h4>
      <p className="pdetails mtb2">{value}</p>
    </div>
  );
}

export default DetailField;
